import { useGetCampaign } from 'entities/campaign';
import { SideModal } from 'shared/ui/SideModal';
import { useModalUrl } from 'shared/lib/hooks';

import { CampaignEditModalBody } from './CampaignEditModalBody';
import type { CampaignEditModalProps } from './model';

export function CampaignEditModal({
  id,
  afterSuccessSaveHandler,
  skipCampaignUpdate,
  skipCampaignRefetch,
  afterCampaignOnHoldHandler,
  afterCampaignDeactivation,
  afterCampaignReactivate,
  openInNewTab = false,
}: CampaignEditModalProps) {
  const getCampaignQuery = useGetCampaign(id);
  const campaign = getCampaignQuery.data?.data;

  const { isOpen } = useModalUrl({ modalId: id, query: getCampaignQuery, openInNewTab });

  if (openInNewTab && !isOpen) {
    return <></>;
  }

  return (
    <SideModal
      autoTestAttributesName="campaign-edit-modal"
      isLoading={getCampaignQuery.isFetching}
    >
      {campaign && (
        <CampaignEditModalBody
          campaign={campaign}
          afterSuccessSaveHandler={afterSuccessSaveHandler}
          afterCampaignOnHoldHandler={afterCampaignOnHoldHandler}
          afterCampaignDeactivation={afterCampaignDeactivation}
          afterCampaignReactivate={afterCampaignReactivate}
          skipCampaignRefetch={skipCampaignRefetch}
          skipCampaignUpdate={skipCampaignUpdate}
        />
      )}
    </SideModal>
  );
}
